import { useCallback } from 'react'
import apis from '../../../ReceivementApi'
import { toast } from 'react-toastify'
import { BatchWithoutBarcode, Product } from 'src/features/receivement/ReceivementTypes'

interface Props {
  selectedBatch?: BatchWithoutBarcode
  selectedProduct?: Product
  batchesWithoutBarcode?: BatchWithoutBarcode[]
  selectedNoRelation: boolean
  supervisorBadge: string
  onFinish: (args0: BatchWithoutBarcode[]) => void
}

export const useRelation = ({
  selectedBatch,
  selectedProduct,
  selectedNoRelation,
  supervisorBadge,
  batchesWithoutBarcode,
  onFinish,
}: Props) => {
  const handleRelation = useCallback(
    async () => {
      if (!selectedBatch && !(selectedProduct || selectedNoRelation)) {
        toast.warn('Não há relacionamento de Lote e Pedido')
        return
      }

      if (!selectedBatch) {
        toast.warn('Lote não selecionado')
        return
      }

      if (!selectedProduct && !selectedNoRelation) {
        toast.warn('"Pedido da AR" ou "Nenhuma das opções" selecionado')
        return
      }

      if (!batchesWithoutBarcode) {
        return
      }

      if (selectedProduct && selectedBatch?.isKg !== selectedProduct?.isKg) {
        const unit = selectedBatch?.isKg ? 'KG' : 'UN'
        toast.warn(`O produto não pode ser associado porque a unidade de recebimento está em ${unit}.`)
        return
      }

      const response = await apis.updateBatchWithoutProduct(
        supervisorBadge,
        selectedBatch.id,
        selectedProduct?.modelId,
      )

      if (!response.isOk) {
        toast.warn('Problema ao relacionar o produto')
        return
      }

      const batches = batchesWithoutBarcode.filter(
        ({ id }) => selectedBatch.id !== id,
      )

      onFinish(batches)

      toast.success('Relacionado com Sucesso')
    },
    [
      batchesWithoutBarcode,
      onFinish,
      selectedBatch,
      selectedNoRelation,
      selectedProduct,
      supervisorBadge,
    ],
  )
  return {
    handleRelation,
  }
}
